import { Pipe, PipeTransform } from '@angular/core';
import { IMenuItem, MenuItemType } from '@models/i-menu-item';
import {MENU_ITEMS} from '@shared/config/menu';

@Pipe({
  name: 'menuChildren',
  standalone: true
})
export class MenuChildrenPipe implements PipeTransform {
  transform(items: IMenuItem[]  = MENU_ITEMS, id: MenuItemType | string): IMenuItem[] {
    if (!items || !id) return [];

    const found = this.findById(items, id);
    return (found && found.children) ? found.children : [];
  }

  // Recursive search for n-level deep children
  private findById(items: IMenuItem[], id: MenuItemType | string): IMenuItem | undefined {
    for (const it of items) {
      if (it.id === id) {
        return it;
      }
      if (it.children && it.children.length) {
        const res = this.findById(it.children, id);
        if (res) return res;
      }
    }
    return undefined;
  }
}
